import React from 'react';
import '../../styles/APSIS.css';

export default function APSISIndustrialPartners() {
  return (
    <div className="apsis-page">
      <div className="apsis-hero">
         <div className="apsis-hero-content">
            <span className="apsis-tag">INDUSTRIAL PARTNERS</span>
            <h1>INDUSTRIAL PARTNERS</h1>
            <p>Meet our strategic industrial partners driving security innovation</p>
         </div>
      </div>

      <div className="apsis-content-grid">
        <section className="apsis-partners-section">
           <div className="section-header-v2">
              <span className="accent-line"></span>
              <h2>STRATEGIC PARTNERS</h2>
           </div>

           <div className="partners-grid">
              <div className="partner-card">
                 <div className="partner-logo">
                    <div className="logo-placeholder">PARTNER</div>
                 </div>
                 <h3>Global Security Corp</h3>
                 <p>Leading manufacturer of security systems and equipment</p>
                 <div className="partner-type">Gold Partner</div>
              </div>

              <div className="partner-card">
                 <div className="partner-logo">
                    <div className="logo-placeholder">PARTNER</div>
                 </div>
                 <h3>TechDefense Industries</h3>
                 <p>Innovative solutions for critical infrastructure protection</p>
                 <div className="partner-type">Platinum Partner</div>
              </div>

              <div className="partner-card">
                 <div className="partner-logo">
                    <div className="logo-placeholder">PARTNER</div>
                 </div>
                 <h3>SecureNet Systems</h3>
                 <p>Network security and cyber defense specialists</p>
                 <div className="partner-type">Silver Partner</div>
              </div>
           </div>
        </section>
      </div>
    </div>
  );
}